import request from '@/utils/request' 

// 搜索应用
export function searchApplication(params){
    return request({
        url:'/application/search',
        method:'get',
        params
    })
}

// 推荐应用
export function recommand(params){
    return request({
        url:'/application/getRecommendRank',
        method:'get',
        params
    })
}

// 最新应用
export function latestRank(params){
    return request({
        url:'/application/getNewestRank',
        method:'get',
        params
    })
}

// 热门应用排行
export function popularRank(params){
    return request({
        url:'/application/getPopularRank',
        method:'get',
        params
    })
}

// 查看应用详情
export function checkApplyDetail(params){
    return request({
        url:'/application/getDetail',
        method:'get',
        params
    })
}


// 订单提交
export function submitBill(data){
    return request({
        url:'/subscribeOrder/submit',
        method:'post',
        data
    })
}

// 留咨
export function crmProductConsult(data){
    return request({
        url:'/crmProductConsult/add',
        method:'post',
        data
    })
}

// 获取订单列表
export function getOrderList(data){
    return request({
        url:'/subscribeOrder/pageQueryMine?pageNo='+data.pageNo+'&pageSize='+data.pageSize,
        method:'post',
        data
    })
}

// 获取订单详情
export function getOrderDetail(data){
    return request({
        url:'/subscribeOrder/queryOne',
        method:'post',
        data
    })
}


// 关闭支付界面通知后端
export function informBack(data){
    return request({
        url:'/subscribeOrder/closePayPage',
        method:'post',
        data
    })
}


// 订单中心-支付
export function payDirect(data){
    return request({
        url:'/subscribeOrder/pay',
        method:'post',
        data
    })
}

// // 订单支付成功后页面
export function getPaidPage(data){
    return request({
        url:'/subscribeOrder/queryWhenPaySuccess',
        method:'post',
        data
    })
}


// // 取消订单
export function cancelOrder(data){
    return request({
        url:'/subscribeOrder/cancel',
        method:'post',
        data
    })
}

// 获取【我的应用】列表
export function getMyApplication(data){
    return request({
        url:'/merchantApp/queryMyApp',
        method:'post',
        data
    })
}

// 获取【优惠券】列表
export function getMyCoupon(data){
    return request({
        url:'/discountCoupon/getMyCoupon',
        method:'post',
        data
    })
}

export function getCouponList(data){
    return request({
        url:'discountCoupon/getCouponList',
        method:'post',
        data
    })
}

// 我的应用-续订
export function renewApplication(data){
    return request({
        url:'/merchantApp/queryForResubscribe',
        method:'post',
        data
    })
}

// 推荐应用
export function recommendApplication(data){
    return request({
        url:'/application/recommend',
        method:'post',
        data
    })
}


// 刷新获取订购信息
export function queryForSubscribe(data){
    return request({
        url:'/appSpec/queryForSubscribe',
        method:'post',
        data
    })
}

// 校验是否可订购
export function checkAppSubscribeAuth(data){
    return request({
        url:'/application/checkSubscribeAuth',
        method:'post',
        data
    })
}


// 获取商户基本信息
export function queryForUserInfo(){
    return request({
        url:'/merchant/getMyMerchantInfo',
        method:'get',
    })
}



// 获取收货地址信息
export function queryForAddressInfo(){
    return request({
        url:'/crmReceiveAddress/getList',
        method:'get',
    })
}



// 新增收货地址信息
export function addAddress(data){
    return request({
        url:'/crmReceiveAddress/add',
        method:'post',
        data
    })
}



// 编辑收货地址信息
export function editAddress(data){
    return request({
        url:'/crmReceiveAddress/edit',
        method:'post',
        data
    })
}


// 删除收货地址
export function deleteAddress(params){
    return request({
        url:'/crmReceiveAddress/drop',
        method:'get',
        params
    })
}



// 确认收货
export function confirmReceipt(data){
    return request({
        url:'/subscribeOrder/confirmGoods',
        method:'post',
        data
    })
}

// 查询我的硬件
export function queryMyHardware(data){
    return request({
        url:'/merchantApp/pageQueryMyHardware?pageNo='+data.pageNo+'&pageSize='+data.pageSize,
        method:'post',
        data
    })
}

// 吐槽提交
export function saveSuggest(data){
    return request({
        url: "/suggestionRecord/save",
        method:'post',
        data
    })
}

// 吐槽类型
export function getSuggestType(){
    return request({
        url: "/suggestionType/getType",
        method: 'get'
    })
}

export function getInvoiceUrl(data){
    return request({
        url:"/invoice/getInvoiceUrl",
        method:'post',
        data
    })
}

// 查询我的需求
export function queryMyNeeds(data){
    return request({
        url:'/merchantApp/pageQueryMyNeeds?pageNo='+data.pageNo+'&pageSize='+data.pageSize,
        method:'post',
        data
    })
}

// 发布创意需求-提交
export function submitNeeds(data){
    return request({
        url:'/needs/publish',
        method:'post',
        data
    })
}
